module.exports = __webpack_public_path__ + "assets/step5-shapes.62e8ab7f.svg";